var map = {
	"./56/bsc-index-top-10/equally-balanced/content.json": 6638,
	"./56/bsc-index-top-10/liquidity/content.json": 5407,
	"./56/bsc-index-top-10/market-cap/content.json": 87489,
	"./56/defi/equally-balanced/content.json": 97841,
	"./56/defi/liquidity/content.json": 37614,
	"./56/defi/market-cap/content.json": 83401,
	"./56/governance/equally-balanced/content.json": 75768,
	"./56/governance/liquidity/content.json": 57611,
	"./56/governance/market-cap/content.json": 9986,
	"./56/metaverse/equally-balanced/content.json": 86723,
	"./56/metaverse/liquidity/content.json": 11657,
	"./56/metaverse/market-cap/content.json": 63068,
	"./97/bsc-index-top-10/equally-balanced/content.json": 27687,
	"./97/bsc-index-top-10/liquidity/content.json": 16008,
	"./97/bsc-index-top-10/market-cap/content.json": 42611,
	"./97/defi/equally-balanced/content.json": 66908,
	"./97/defi/liquidity/content.json": 87737,
	"./97/defi/market-cap/content.json": 28060,
	"./97/governance/equally-balanced/content.json": 96721,
	"./97/governance/liquidity/content.json": 2173,
	"./97/governance/market-cap/content.json": 89804,
	"./97/metaverse/equally-balanced/content.json": 56678,
	"./97/metaverse/liquidity/content.json": 45507,
	"./97/metaverse/market-cap/content.json": 64429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97397;